import styled from 'styled-components'

export const SelectCheckSC = styled.div`
  grid-area: next-check-select;
  max-width: 320px;
  width: 100%;
  
  margin-bottom: 16px;
`
